/** Time constants with no imports — safe for modules that load during consts/types cycles. */
export const DAY_IN_MS = 24 * 60 * 60 * 1000;
